import React from 'react';
import { createRoot } from 'react-dom/client';
import { MeshGradientBG } from '../components/MeshGradientBG';

const bg = document.getElementById('bg');
if (bg) {
    const root = createRoot(bg);
    root.render(React.createElement(MeshGradientBG));
} else {
    console.warn('bg not found');
}

const langSwitcher = document.getElementById('language-switcher') as HTMLSelectElement;
if (langSwitcher) {
    langSwitcher.addEventListener('change', (e) => {
        const target = e.target as HTMLSelectElement;
        window.location.href = target.value;
    });
}


function initOnScroll() {
    const page = document.querySelector(".page") as HTMLElement;
    if (page) {
        const updateOffset = () => {
            document.documentElement.style.setProperty('--offset', `${page.scrollTop}px`);
        };
        page.addEventListener('scroll', updateOffset);
        updateOffset();
    }
}
initOnScroll();